/* eslint-disable no-nested-ternary */
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const GridWrapper = styled("div")(() => ({
  width: "100vw",
  overflow: "auto",
  padding: "0.9rem 2rem",
}));

interface ShipmentTypeTextProps {
  isTypeAir?: boolean;
}
export const ShipmentTypeText = styled("span")(({ isTypeAir }: ShipmentTypeTextProps) => ({
  color: isTypeAir ? "#38cfc4" : "#308cdb",
  fontSize: "0.75rem",
  lineHeight: "16px",
  fontWeight: 400,
  fontFamily: "Manrope",
}));

interface DelayedDaysProps {
  type: string;
}
export const DelayedDays = styled("span")(({ type }: DelayedDaysProps) => ({
  color: type === "YES" ? colors.error500 : colors.brandBlue600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

const styles = makeStyles(() => ({
  badge: {},
}));

export default styles;
